import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';
import HorizontalTileRetail from '@components/styled-UI/HorizontalTileRetail';
import Alert from '@components/styled-UI/Alert';

import LoaderTable from '@loaders/LoaderTable';

import PaymentDetailsOrderRetailDetail from './online-orders/PaymentDetailsOrderRetailDetail';

import { IRetailOrderDetails } from '@interfaces/myPurchasesInterfaces';

import { getLabelFallback } from '@utils/utils';

import URLS from '@utils/urlList';
import { getStringFromDate } from '@utils/dateUtils';

import RetailOrder from '@images/svg-icons/retailPrescription.svg';
import PhoneLogo from '@images/svg-icons/phoneLogo.svg';
import BoxImage from '../styled-UI/BoxImage';
import { useEffect, useState } from 'react';
import { getCookie } from '@utils/cookie';
import { getPrescriptionInfoForOrders } from '@services/myPurchasesServices';
import { handleContactLensesReorder } from '@utils/pages-utils/MyPurchasesUtils';

interface Props {
    orderDetail: IRetailOrderDetails;
}

const OrderRetailDetailOverview = ({ orderDetail }: Props): JSX.Element => {
    const {
        orderNumber,
        orderDate,
        orderStatus,
        hasContactLenses,
    } = orderDetail;

    const dispatch = useDispatch();

    const config = useSelector((state: RootState) => state.common.config);

    const urlDownloadReceipt = URLS.DOWNLOAD_RECEIPT_METHOD.replace('{storeId}', config.storeId).replace('{orderId}', orderNumber);
    const isOrderStatusCompleted = orderStatus.toLowerCase().includes('dispensed');
    const isMobile = useSelector((state: RootState) => state.common.isMobile);

    const [prescriptionDetail, setPrescriptionDetail] = useState(null);

    const [onlyOneIsNotBuyable, setOnlyOneIsNotBuyable] = useState(false);
    const [isAtLeastOneBuyable, setIsAtLeastOneBuyable] = useState(false);

    const renderSuggestion = (): JSX.Element => {
        return (
            <div className="primary-message medium align-left suggestion">
                {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_1_SUGGEST')}
                <a
                    href={`${config.visitStoreUrl + orderDetail?.store?.number}`}
                >
                    {getLabelFallback(
                        'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_PLACEHOLDER'
                    )}
                </a>
                {getLabelFallback('MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_2_SUGGEST')}
                <a
                    href={'/to-us/returns'}
                >
                    {getLabelFallback(
                        'MYPURCHASES_RETAIL_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_PLACEHOLDER_RETURN'
                    )}
                </a>
                <span className='bold'>.</span>
            </div>
        );
    };

    const renderSuggestionTop = (): JSX.Element => {
        return (
            <div className="primary-message medium align-left suggestion-top">
                {getLabelFallback('MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_COMPLETED_TOP_SUGGEST')}
                <a
                    href="#"
                    onClick={() =>
                        window.open(
                            config.callFromComponentToTO.myPurchases.inStorePurchases.trustpilot,
                            '_parent'
                        )
                    }
                >
                    {getLabelFallback(
                        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_COMPLETED_SUGGEST_TOP_PLACEHOLDER'
                    )}
                </a>
            </div>
        );
    };

    // const renderQuotationAddress = (): JSX.Element => {
    //     return (
    //         <div className="quotation-address primary-message medium align-left">
    //             <span>
    //                 {getLabelFallback(
    //                     'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_QUOTE_ADDRESS_LABEL'
    //                 )}
    //             </span>
    //             <span className=" primary-message medium align-left bold">{quoteAddress}</span>
    //         </div>
    //     );
    // };

    useEffect(() => {
        console.log("LOGGER: Order Status " + orderStatus.toLowerCase());
        if((orderDetail?.orderItems.filter(element => element.productKind === 'FRAMES' || element.productKind === 'SUN' || element.productKind === 'LENSES').length > 0) 
            && (orderDetail?.orderItems.filter(element => element.lensBrand != null).length > 0)){
                const email = getCookie('email_address');
                getPrescriptionInfoForOrders(config.isMockRequest, config.storeId, email)
                    .then((res: any) => {
                        if (!!res) {
                            const prescriptionResponse = res.response.filter(element => element.prescriptionId === orderDetail.prescriptionId)
                            console.log("LOGGER: order prescriptionId " + orderDetail.prescriptionId);

                            setPrescriptionDetail(prescriptionResponse[0]);
                        } else {
                            console.error('>>> Error on retrieve right CL details');
                        }
                    })
                    .catch(error => {
                        console.error(
                            '>>> Error on retrieve prescription Retail',
                            error.status,
                            ', error: ',
                            error
                        );
                    })
        }

        const arrayOfBuyable = orderDetail?.orderItems.filter(element => element.buyable === "true")
        if (arrayOfBuyable.length > 0) {
            setIsAtLeastOneBuyable(true)
        }

        const arrayOfContacts = orderDetail?.orderItems.filter(element => element.productKind === "CONTACTS")
        if (arrayOfBuyable.length != 0 && arrayOfBuyable.length < arrayOfContacts.length) {
            setOnlyOneIsNotBuyable(true)
        }
    }, [])

    return (
        <div role="region" aria-label="Order detail overview" className="order-detail-overview">
            <div className="order-in-store-text">
                <RetailOrder />
                <span>{getLabelFallback('MYPROFILE_MY_ORDERS_RETAIL_LABEL')}</span>
            </div>
            <div className="order-recap">
                <div className="order-recap-left">
                    <div className="row">
                        <div className="label">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_ORDER_NUMBER_LABEL'
                            )}
                        </div>
                        <div className="value">{orderNumber}</div>
                    </div>
                    <div className="row">
                        <div className="label">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_ORDER_DATE_LABEL'
                            )}
                        </div>
                        <div className="value">{getStringFromDate(new Date(orderDate), 'MM/dd/yyyy')}</div>
                    </div>
                </div>
                <div className="order-recap-right">
                    {/* {(hasContactLenses && (orderStatus.toLowerCase() === 'dispensed' || orderStatus.toLowerCase() === 'delivered')) && (
                        <button
                            className="primary-button button-size-small"
                        >
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_REORDER_NOW_CTA_LABEL'
                            )}
                        </button>
                    )} */}

                    {/**TODO: Handle future CR */}
                    {/*  <button
                        className="primary-button button-size-small"
                        data-element-id="OrderDetails_TrackMyOrder"
                    >
                        {getLabelFallback(
                            'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_TRACK_YOUR_ORDER_CTA_LABEL'
                        )}
                    </button> */}
                </div>
            </div>
            {/* {quoteAddress && renderQuotationAddress()} */}
            {/* {(readyForPickUpAddress || readyForPickUpPhone) && (
                <Alert customStyle="info">
                    <div className="pickup-info-alert">
                        <span className="primary-message bold medium align-left">
                            {getLabelFallback(
                                'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_READY_FOR_PICKUP_TITLE'
                            )}
                        </span>
                        {readyForPickUpAddress && (
                            <div className="primary-message small align-left">
                                {readyForPickUpAddress}
                            </div>
                        )}
                        <div className="contacts">
                            {readyForPickUpPhone && (
                                <a
                                    href={`tel:${readyForPickUpPhone}`}
                                    data-element-id="OrderDetails_PhoneNum"
                                    className="primary-message small align-left"
                                >
                                    {readyForPickUpPhone.replace(
                                        /(\d{3})(\d{3})(\d{4})/,
                                        '($1) $2-$3'
                                    )}
                                </a>
                            )}
                            {readyForPickUpAddress && (
                                <a
                                    href={`http://maps.google.com/?q=${readyForPickUpAddress}`}
                                    target="_blank"
                                    data-element-id="OrderDetails_GetDirections"
                                    className="primary-message small align-right"
                                >
                                    {getLabelFallback(
                                        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAILS_READY_FOR_PICKUP_ADDRESS_PLACEHOLDER'
                                    )}
                                </a>
                            )}
                        </div>
                    </div>
                </Alert>
            )} */}
            {/*isOrderStatusCompleted && renderSuggestionTop()*/}
            {/* {globalOrderDetailsRequestStatus === 'LOADING' && (
                <LoaderTable className="order-detail-loader" />
            )} */}
            {orderDetail?.orderItems?.length && (
                <div className="horizontal-tile-container">
                    {orderDetail.orderItems.map(orderItem => (
                        <HorizontalTileRetail
                            orderItem={orderItem}
                            orderId={orderNumber}
                            storeNumber={orderDetail?.store?.phone}
                            prescriptionInfo={prescriptionDetail}
                            onlyOneIsNotBuyable={onlyOneIsNotBuyable}
                            isTrackItem={orderDetail?.isTrackItem}
                            hasPrescriptionId={orderDetail?.prescriptionId}
                        />
                    ))}
                </div>
            )}
            {!!orderDetail?.store && (
                <div className="store-tile-container">
                    <div className="store-tile">
                        <div className="header">
                            Order placed at
                        </div>
                        <div className="body">
                            <div className="map-img">
                                <BoxImage
                                    imageUrl={orderDetail?.store?.mapImpage}
                                    fallbackLabel={getLabelFallback('IMAGE_NON_AVAILABLE_LABEL')}
                                    imageAlt="Store image"
                                />
                            </div>
                            <div className="body-right">
                                <div className="store-details">
                                    <div className="store-details-label name-and-address">
                                        <span className="name">{orderDetail?.store?.storeName}</span>
                                        <span className="address">{orderDetail?.store?.address + ', ' + orderDetail?.store?.city + ', ' + orderDetail?.store?.country + ' ' + orderDetail?.store?.postalCode}</span>
                                    </div>
                                    <div className="store-details-label phone">
                                        <PhoneLogo />
                                        {!isMobile
                                            ? (<span>{orderDetail?.store?.phone}</span>)
                                            : (<a href={`tel:${orderDetail?.store?.phone.replace(/\D/g, '')}`}>{orderDetail?.store?.phone}</a>)
                                        }

                                    </div>
                                    <div className="store-details-label links">
                                        <a href={`http://maps.google.com/?q=${encodeURIComponent(orderDetail?.store?.address + ' ' + orderDetail?.store?.city + ' ' + orderDetail?.store?.country + ' ' + orderDetail?.store?.postalCode)}`} target="_blank">Get directions</a>
                                        <a href={`${config.visitStoreUrl + orderDetail?.store?.number}`} target="_blank">Visit store page</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <PaymentDetailsOrderRetailDetail orderDetail={orderDetail} />
            {isOrderStatusCompleted && renderSuggestion()}
        </div>
    );
};
export default OrderRetailDetailOverview;
